import axios from 'axios'

import { HttpMethod, HttpStatusCode, browserStorageKeys } from '@/Shared/domain'
import { loginSiteUrl } from '@/Shared/infrastructure/dynamicEndpoints'
import { acceptLanguage } from '@/Shared/ui/language'

export const getGatewayConfigClean = axios.create({
  baseURL: import.meta.env.VITE_GATEWAY_URL,
})

const isDevelopment = process.env.NODE_ENV === 'development'

export const axiosFetch = async (
  url: string,
  method: HttpMethod,
  values?: object,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  try {
    const { data } = await getGatewayConfigClean({
      url: url,
      method: method,
      data: values,
      headers: {
        'Authorization':
          'Bearer ' + window.localStorage.getItem(browserStorageKeys.token),
        'Accept-Language': acceptLanguage,
      },
    })
    return data
  } catch (err) {
    if (axios.isAxiosError(err)) {
      if (
        !isDevelopment &&
        err.response?.status === HttpStatusCode.unauthorized &&
        loginSiteUrl !== ''
      ) {
        window.location.href = loginSiteUrl
      }
      return err.response?.data
    } else {
      return err
    }
  }
}

export const axiosFetchV2 = async (
  url: string,
  method: HttpMethod,
  values?: object,
  config?: { headers?: Record<string, string> },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<any> => {
  try {
    const { data } = await getGatewayConfigClean({
      url: url,
      method: method,
      data: values,
      headers: {
        'Authorization':
          'Bearer ' + window.localStorage.getItem(browserStorageKeys.token),
        'Accept-Language': acceptLanguage,
        ...(config?.headers || {}),
      },
    })
    return data
  } catch (err) {
    if (axios.isAxiosError(err)) {
      if (
        !isDevelopment &&
        err.response?.status === HttpStatusCode.unauthorized &&
        loginSiteUrl !== ''
      ) {
        window.location.href = loginSiteUrl
      }
      return err.response?.data
    } else {
      return err
    }
  }
}
